import React, { Component } from 'react'
import SimpleTabs from './components/OngoingListTabPanel';

class OngoingListTab extends Component {
    render() {
        return (
            <div>
              <SimpleTabs />
            </div>
        )
    }
}
  
export default OngoingListTab
  